import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, ArrowLeft } from "lucide-react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import WavyDivider from "../components/WavyDivider";
import useSEO from "../hooks/useSEO";
import { articles, formatDate } from "../data/articles";

const BlogList = () => {
  useSEO({
    title: "Blog Shiatsu — Conseils, bienfaits et réflexions | Catherine' Shiatsu",
    description:
      "Articles de blog autour du Shiatsu : origines, bienfaits, stress, sommeil, douleurs, pratiques en entreprise. Par Catherine SAC-EPEE, praticienne à La Ciotat.",
    keywords:
      "blog shiatsu, articles shiatsu, bien-être, santé énergétique, La Ciotat",
    type: "website",
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "Blog",
      name: "Le blog Catherine' Shiatsu",
      description:
        "Articles sur le Shiatsu, la médecine énergétique et le bien-être.",
      blogPost: articles.map((a) => ({
        "@type": "BlogPosting",
        headline: a.title,
        datePublished: a.date,
        url: `${window.location.origin}/blog/${a.slug}`,
      })),
    },
  });

  return (
    <div className="site">
      <Header />
      <main className="page-main">
        <section className="blog-hero">
          <div className="blog-hero-inner">
            <WavyDivider />
            <h1 className="blog-hero-title">Le blog Catherine' Shiatsu</h1>
            <p className="blog-hero-sub">
              Articles, conseils et réflexions pour mieux comprendre le Shiatsu et ses bienfaits au quotidien.
            </p>
            <Link to="/" className="back-link"><ArrowLeft size={16} /> Retour à l’accueil</Link>
          </div>
        </section>

        <section className="section blog-list">
          <div className="blog-grid blog-grid--list">
            {articles.map((a) => (
              <Link key={a.slug} to={`/blog/${a.slug}`} className="blog-card">
                <div className="blog-cover">
                  <img src={a.cover} alt={a.title} loading="lazy" />
                </div>
                <div className="blog-body">
                  <div className="blog-meta">
                    <span className="blog-category">{a.category}</span>
                    <span className="blog-dot">·</span>
                    <time>{formatDate(a.date)}</time>
                    <span className="blog-dot">·</span>
                    <span>{a.readTime} min</span>
                  </div>
                  <h2 className="blog-title">{a.title}</h2>
                  <p className="blog-excerpt">{a.excerpt}</p>
                  <span className="blog-more">
                    Lire l’article <ArrowRight size={16} strokeWidth={1.6} />
                  </span>
                </div>
              </Link>
            ))}
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default BlogList;
